export default {
    params: ['doc'],
    validate: (value, { doc }) => doc != value,
    message: (field) => `${field} não pode ser igual ao do paciente.`,
}